import { DashboardContainer } from "./Dashboard.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default DashboardContainer;
